import Fade from 'react-reveal/Fade'
import React from 'react'
import styled from 'styled-components'

export default function ProjectName({name, paddingLeft = false}) {
  return (
    <StyledComponent className="project-name">
      <Fade>
        <h3>{name}</h3>
      </Fade>
    </StyledComponent>
  )
}

const StyledComponent = styled.div`
  margin-bottom: 1rem;

  h3 {
    font-size: 2.1rem;
    font-weight: 400;
    line-height: 1.2;
    margin: 0;
    padding: ${props => (props.paddingLeft ? '0 0 0 1rem' : '0 0 0 0')};
    text-transform: uppercase;

    @media (min-width: 375px) {
      font-size: 2.3rem;
    }
  }
}`
